import { NgModule } from "@angular/core";
import { Routes, RouterModule, UrlSegment } from "@angular/router";
import { AuthGuard } from "./helper/authGuard/auth.guard";
import { JoinTeamComponent } from "./modules/admin/components/setting/join-team/join-team.component";
import { PageNotFoundComponent } from "./shared/components/page-not-found/page-not-found.component";
const routes: Routes = [
  // A bare URL on dashboard.paymish.com must go to the dashboard. The
  // storefront is mounted at "" for shop.paymish.com, so without this the
  // root of the dashboard hostname renders a blank page.
  {
    matcher: (segments: UrlSegment[]) =>
      segments.length === 0 && window.location.hostname !== "shop.paymish.com"
        ? { consumed: [] }
        : null,
    redirectTo: "/dashboard",
  },
  // wayfinder map P-T-L/merchant-angular#207 - shop.paymish.com/<slug> has
  // no path prefix, unlike every other hostname-shared route below. Placed
  // first since its own UrlMatcher already gates on hostname (falls
  // through instantly on any hostname other than shop.paymish.com) - see
  // storefront-routing.module.ts for why it must intercept every single-
  // segment path there, ahead of the named routes that follow.
  {
    path: "",
    loadChildren: () =>
      import("./modules/storefront/storefront.module").then(
        (m) => m.StorefrontModule
      ),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./modules/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "pay",
    loadChildren: () =>
      import("./modules/payment-link/payment-link.module").then(
        (m) => m.PaymentLinkModule
      ),
  },
  {
    path: "checkout",
    loadChildren: () =>
      import("./modules/initialize-checkout/initialize-checkout.module").then(
        (m) => m.InitializeCheckoutModule
      ),
  },
  {
    path: "dispute",
    loadChildren: () =>
      import("./modules/dispute/dispute.module").then((m) => m.DisputeModule),
  },
  {
    path: "terms",
    loadChildren: () =>
      import("./modules/terms-and-service/terms-and-service.module").then(
        (m) => m.TermsAndServiceModule
      ),
  },
  {
    path: "buy",
    loadChildren: () =>
      import("./modules/preview-product/preview-product.module").then(
        (m) => m.PreviewProductModule
      ),
  },
  {
    path: "team/join-team",
    component: JoinTeamComponent,
  },
  {
    path: "transaction-status",
    loadChildren: () =>
      import("./modules/success-page/success-page.module").then(
        (m) => m.SuccessPageModule
      ),
  },
  {
    path: "digitalproducts/:id",
    loadChildren: () =>
      import("./modules/download-product/download-product.module").then(
        (m) => m.DownloadProductModule
      ),
  },
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./modules/admin/admin.module").then((m) => m.AdminModule),
  },
  {
    path: "**",
    component: PageNotFoundComponent, // Wildcard route for page not found
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
